



















import {Component, Prop, Watch, Mixins} from 'vue-property-decorator';
import UsersWatching from "./components/users-watching/UsersWatching.vue"
import CountersPanel from "../common/counters-panel/CountersPanel.vue";
import BannerLink from "../common/BannerLink.vue";
import {Rating} from "@api/models/Rating";

import {OnlineCounter} from "../../mixins/OnlineCounter";

@Component({
    components: { CountersPanel, UsersWatching, BannerLink }
})
export default class InfoPanel extends Mixins(OnlineCounter) {
    static BANNER_TYPE = 'leftViewersPanelBanner';

    @Prop({ default: 0}) likes?: Rating;
    @Prop({ default: 0 }) commentsCount: number;
    @Prop({ required: true}) counterId: string;
    @Prop({ default: false }) showLeave: boolean;
    @Prop({ default: false }) useGeneralCounter: boolean;

    timerId: number | null = null;
    localCounterId = "";
    onlineCounterTake = 100;

    mounted() {
        if(!this.onlineUsersCounterId) {
            this.onActivate();
        }
    }

    activated() {
        this.onActivate();
    }

    async onActivate() {
        this.onlineUsersCounterId = this.counterId;

        this.useGeneralCounter && this.$store.dispatch('onlineUsers/addWatches', [{
            name: "general",
            take: 100
        }]);

        await this.subscribeToOnlineUsersUpdate();
    }

    deactivated() {
        this.unsubscribeFromOnlineUsersUpdate();
        this.useGeneralCounter && this.$store.dispatch('onlineUsers/removeWatches', ["general"]);
        this.onlineUsersCounterId = ""
    }

    @Watch('counterId')
    watchCounterId(newValue: string, oldValue: string) {
        if(newValue !== oldValue) {
            this.reInitOnlineUsersUpdate(newValue)
        }
    }

    reInitOnlineUsersUpdate(newCounterId: string) {
        this.unsubscribeFromOnlineUsersUpdate();
        this.onlineUsersCounterId = newCounterId;
        this.subscribeToOnlineUsersUpdate();
    }

    get onlineUserIds(): number[] {
        return this.useGeneralCounter ? this.$store.getters['onlineUsers/counter']("general")?.userIds || [] : this.counter?.userIds || []
    }

    get onlineCount() {
        return this.useGeneralCounter ? this.$store.getters['onlineUsers/counter']("general")?.count || 0 : this.counter?.count || 0;
    }

    set onlineUsersCounterId(value: string) {
        this.localCounterId = value
    }

    get onlineUsersCounterId() {
        return this.localCounterId;
    }

    get bannerImage() {
        return this.$store.getters['events/selectedEventViewParam']('banners', {})?.[this.bannerType]?.imageUrl;
    }

    get bannerType() {
        return InfoPanel.BANNER_TYPE;
    }
}
